module.exports = __webpack_public_path__ + "static/Lee-0604b0500fd7fba47fbc78c97ba6024b.png";